const routes = {
  '/app/company-dashboard': {
    fetch: () =>
      import(
        /* webpackChunkName: 'company-dashboard-route' */ 'app/company-dashboard/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
